'use client';

import { useState } from 'react';
import Box from '@mui/material/Box';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface AccordionProps {
	titles: { [key: string]: string };
	contents: { [key: string]: React.ReactNode };
	color?: string;
	expandedColor?: string;
	backgroundColor?: string;
	fontWeight?: number;
}

const Accordion = ({ titles, contents, color, backgroundColor, expandedColor, fontWeight }: AccordionProps) => {
	const [expanded, setExpanded] = useState<string | null>(null);

	const handleAccordionChange = (panel: string) => (_: React.SyntheticEvent, newExpanded: boolean) => {
		setExpanded(newExpanded ? panel : null);
	};

	return (
		<Box>
			{Object.entries(titles).map(([key, label]) => (
				<MuiAccordion
					disableGutters={true}
					key={key}
					expanded={expanded === key}
					onChange={handleAccordionChange(key)}
					sx={{
						backgroundColor: backgroundColor,
						boxShadow: 'none',
						'&.Mui-expanded:before': {
							opacity: '1',
						},
					}}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon sx={{ color: color }} />}
						aria-controls={`${key}-content`}
						id={`${key}-header`}
						sx={{
							'&.Mui-expanded': {
								minHeight: '48px',
							},
							'& div.Mui-expanded': {
								margin: '12px 0',
							},
						}}
					>
						<Typography
							sx={{
								color: expanded === key ? (expandedColor ?? 'primary.main') : color,
								fontWeight: fontWeight ?? 600,
							}}
						>
							{label}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>{contents[key]}</AccordionDetails>
				</MuiAccordion>
			))}
		</Box>
	);
};

export default Accordion;
